import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import scopeText from '../../texts';
import { getEventProvince } from '../../services/provinces';
import { selectEvent } from '../../reducers/events';
import { switchView } from '../../reducers/view';
import deleteEvent from '../../services/deleteEvent';

import DeleteEventModal from './DeleteEventModal.jsx';

import '../css/EventDetailsContent.css';

const dateFormat = 'DD.MM.YYYY';

const mapStateToProps = state => ({
  isLoggedIn: state.login.loggedIn,
  user: state.login.user,
  isAdmin: state.login.isAdmin
});

const mapDispatchToProps = dispatch => ({
  deleteEvent: eventId => deleteEvent(eventId, dispatch),
  changeView: viewName => dispatch(switchView(viewName)),
  showOnMap: eventId => showOnMap(dispatch, eventId)
});

function showOnMap(dispatch, eventId) {
  dispatch(selectEvent(eventId));
  dispatch(switchView('MAP'));
}

class EventDetailsContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showDeleteConfirm: false
    };

    this.deleteEvent = this.deleteEvent.bind(this);
    this.showDeleteModal = this.showDeleteModal.bind(this);
  }

  showDeleteModal(e) {
    e.preventDefault();
    this.setState({ showDeleteConfirm: true });
  }

  deleteEvent() {
    this.props.deleteEvent(this.props.event.EVENT_ID);
    this.setState({ showDeleteConfirm: false });
  }

  adminControls() {
    if (this.props.isLoggedIn && this.canEditEvent()) {
      return (
        <div className="adminTools">
          <hr />
          <span>Admin-työkalut: </span>
          <a role="button" tabIndex="0" onClick={() => { this.props.changeView('EDITOR'); }}>Muokkaa</a>
          <span> | </span>
          <a href="/deleteEvent" onClick={this.showDeleteModal}>Poista</a>
        </div>
      );
    }

    return (<div />);
  }

  canEditEvent() {
    return this.props.user === this.props.event.CREATED_BY || this.props.isAdmin;
  }

  showOnMap = (e) => {
    this.props.showOnMap(this.props.event.EVENT_ID);
    e.preventDefault();
  }

  render() {
    if (Object.keys(this.props.event).length !== 0) {
      const event = this.props.event;

      return (
        <div>
          <div className="eventDetailsHeader">
            {!this.props.calendar && <h2>{event.EVENT_NAME}</h2>}
            <strong>{
              moment(event.START_DATE).format(dateFormat)}
              { '–' }
              {moment(event.END_DATE).format(dateFormat)}
            </strong>
          </div>

          <div className="eventDetailsDescription">
            {event.DESCRIPTION}
          </div>

          <div className="eventDetailsOwnerInfo">
            <h4>Toteuttajan yhteystiedot</h4>
            {event.EXECUTOR}<br />
            {event.CONTACT_NAME}<br />
            {event.CONTACT_PHONE}<br />
            <a href={`mailto:${event.CONTACT_EMAIL}`}>{event.CONTACT_EMAIL}</a>
          </div>

          <div className="eventDetailsParticipators">
            <h4>Osallistujat</h4>
            {event.PARTICIPANT}
          </div>

          <div className="eventDetailsScope">
            <h4>Laajuus</h4>
            {scopeText(event.SCOPE)}
          </div>

          <div className="eventDetailsLocation">
            <h4>Sijainti</h4>

            {getEventProvince(event)}{ ' ' }

            {this.props.calendar &&
              <a href="/showOnMap" onClick={this.showOnMap}>Näytä kartalla</a>
            }
          </div>

          <div className="eventDetailsKeywords">
            <h4>Asiasanat</h4>
            {event.KEYWORDS.toString().replace(/,/g, ', ')}
          </div>

          <div className="eventDetailsLinks">
            <h4>Linkit ja lisätiedot</h4>
            {event.LINKS.map(link => (
              <div key={link.LINK_ID}><a href={link.LINK_URL} target="new">{link.LINK_URL}</a></div>
            ))}
          </div>

          {this.adminControls()}

          <DeleteEventModal
            showDeleteConfirm={this.state.showDeleteConfirm}
            onYesClick={this.deleteEvent}
            onNoClick={() => this.setState({ showDeleteConfirm: false })}
            event={event}
          />
        </div>
      );
    }

    return (
      <div />
    );
  }
}

EventDetailsContent.propTypes = {
  event: PropTypes.object.isRequired,
  calendar: PropTypes.bool,
  showOnMap: PropTypes.func,
  isLoggedIn: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  user: PropTypes.string,
  deleteEvent: PropTypes.func.isRequired,
  changeView: PropTypes.func.isRequired
};

EventDetailsContent.defaultProps = {
  calendar: false,
  showOnMap: undefined,
  user: undefined
};

export default connect(mapStateToProps, mapDispatchToProps)(EventDetailsContent);



// WEBPACK FOOTER //
// ./src/components/eventDetails/EventDetailsContent.jsx